export enum ToastMessageType {
  Success,
  Info,
  Warning,
  Error,
}
